import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Select, SpinnerSmall } from '@eyesee/eyesee-hub-npm-ui';
import { instructionStore, instructionStoreData } from '../../stores/instructionsStore';
import SaveButton from '../../components/SaveButton/SaveButton';
import { useFormik } from 'formik';
import ISO6391 from 'iso-639-1';
import * as yup from 'yup';
import Translations from '../../components/Translations/Translations';

import './instructions.scss';

const validation = yup.object({
    'Thank you for participating': yup.string().required('Please fill in this field.'),
    'Please follow these steps for a successful installation': yup.string().required('Please fill in this field.'),
    'At the end of the tutorial you will be able to click on the': yup.string().required('Please fill in this field.'),
    'button which will transfer you to the Chrome Web Store, where EyeSee extension needs to be installed': yup
        .string()
        .required('Please fill in this field.'),
    Continue: yup.string().required('Please fill in this field.'),
    'Click on the Add to Chrome button next to the EyeSee Research - UX Capture Chrome extension': yup
        .string()
        .required('Please fill in this field.'),
    'Click on the “Add extension” button to have it installed on your Chrome browser': yup.string().required('Please fill in this field.'),
    Next: yup.string().required('Please fill in this field.'),
});
interface initialValues_t {
    [key: string]: string;
}
const DownloadInstructionsPage = observer(() => {
    useEffect(() => {
        instructionStore.getPageTranslations();
    }, []);
    const formik = useFormik({
        initialValues: {
            'Thank you for participating': instructionStoreData.pageTranslations
                ? instructionStoreData.pageTranslations['Thank you for participating']
                : '',
            'Please follow these steps for a successful installation': instructionStoreData.pageTranslations
                ? instructionStoreData.pageTranslations['Please follow these steps for a successful installation']
                : '',
            'At the end of the tutorial you will be able to click on the': instructionStoreData.pageTranslations
                ? instructionStoreData.pageTranslations['At the end of the tutorial you will be able to click on the']
                : '',
            'button which will transfer you to the Chrome Web Store, where EyeSee extension needs to be installed':
                instructionStoreData.pageTranslations
                    ? instructionStoreData.pageTranslations[
                          'button which will transfer you to the Chrome Web Store, where EyeSee extension needs to be installed'
                      ]
                    : '',
            Continue: instructionStoreData.pageTranslations ? instructionStoreData.pageTranslations['Continue'] : '',
            'Click on the Add to Chrome button next to the EyeSee Research - UX Capture Chrome extension': instructionStoreData.pageTranslations
                ? instructionStoreData.pageTranslations['Click on the Add to Chrome button next to the EyeSee Research - UX Capture Chrome extension']
                : '',
            'Click on the “Add extension” button to have it installed on your Chrome browser': instructionStoreData.pageTranslations
                ? instructionStoreData.pageTranslations['Click on the “Add extension” button to have it installed on your Chrome browser']
                : '',
            Next: instructionStoreData.pageTranslations ? instructionStoreData.pageTranslations['Next'] : '',
        },
        enableReinitialize: true,
        validationSchema: validation,
        onSubmit: async (values: initialValues_t) => {
            instructionStore.saveTranslation(instructionStoreData.selectedPageLang,'pageTranslation', values);
            instructionStore.getPageTranslations();
        },
    });
    let pageLangNames = Object.keys(instructionStoreData.langList);
    const [selectedPageLang, setSelectedPageLang] = useState<string>('English');
    const onLangChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        instructionStoreData.editPageTranslations = false;
        instructionStoreData.selectedPageLang = instructionStoreData.langList[e.target.value].code;
        setSelectedPageLang(instructionStoreData.langList[e.target.value].name);
        instructionStore.getPageTranslations();
    };
    const handleChange = (key: string, e: React.ChangeEvent<HTMLTextAreaElement>) => {
        if (!instructionStoreData.editPageTranslations) return;
        formik.handleChange(e);
        const target = e.target as HTMLTextAreaElement;
    };
    return (
        <div className="instructions-wrapper">
            <div className="instructions-wrapper__select">
                <p>Choose translation language</p>
                <Select title="Select language" onChange={onLangChange} options={pageLangNames} value={selectedPageLang} />
                <button
                    onClick={() => {
                        instructionStoreData.editPageTranslations = true;
                    }}
                    className="btn c-btn edit-btn"
                >
                    <i title="Edit" className="material-icons prefix">
                        edit
                    </i>
                    Edit
                </button>
            </div>
            <div className="instructions-wrapper__text-wrapper">
                {instructionStoreData.state === 'loading' ? (
                    <div className="project-spinner">
                        <SpinnerSmall />
                    </div>
                ) : (
                    <Translations edit={instructionStoreData.editPageTranslations} page="instructions_page" formik={formik} onChange={handleChange} />
                )}
            </div>
            <SaveButton title="Save" onClick={formik.handleSubmit} />
        </div>
    );
});
export default DownloadInstructionsPage;
